<template>
  <img src="../images/ajax-loader-16.gif">
</template>
